<template>
  <head>
    <title>{{ $t("login") }}</title>
  </head>
  <NavbarComponent />
  <div class="login-view">
    <div class="container d-flex justify-content-center align-items-center">
      <form
        class="form w-100"
        style="margin-top: 50px"
        @submit.prevent="Login()"
      >
        <p class="title">{{ $t("welcomeBack") }}</p>

        <label>
          <input
            placeholder=""
            type="email"
            class="input"
            name="email"
            v-model="email"
          />
          <span
            :style="{
              left: $i18n.locale == 'ar' ? '' : '10px',
              right: $i18n.locale == 'ar' ? '10px' : '',
            }"
            >{{ $t("email") }}</span
          >
        </label>

        <label>
          <input
            placeholder=""
            type="password"
            class="input"
            name="password"
            v-model="password"
          />
          <span
            :style="{
              left: $i18n.locale == 'ar' ? '' : '10px',
              right: $i18n.locale == 'ar' ? '10px' : '',
            }"
            >{{ $t("password") }}</span
          >
        </label>
        <div
          class="Error"
          :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'"
          style="text-align: start"
          v-if="ErrorMessage"
        >
          {{ ErrorMessage }}
        </div>
        <button class="submit">{{ $t("login") }}</button>
        <!-- <p class="signin">
          {{ $t("DontHaveAccount") }}
          <a :href="'/register'">{{ $t("Register") }}</a>
        </p> -->
      </form>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import store from "@/store";
import NavbarComponent from "@/components/NavbarComponent.vue";

export default {
  name: "login-view",
  components: {
    NavbarComponent,
  },
  data() {
    return {
      email: "",
      password: "",
      ErrorMessage: "",
    };
  },
  methods: {
    Login() {
      store.state.loading_state = 1;
      this.ErrorMessage = "";
      if (this.email == "" || this.password == "") {
        this.$i18n.locale == "ar"
          ? (this.ErrorMessage = "يرجى إدخال الايميل وكلمة المرور")
          : (this.ErrorMessage = "Please enter Email and Password");
        store.state.loading_state = 0;
        return;
      }
      const fd = new FormData();
      fd.append("email", this.email);
      fd.append("password", this.password);
      axios
        .post(store.state.server + "api/login", fd)
        .then((response) => {
          if (response.data.msg == "Invalid email or password") {
            this.$i18n.locale == "ar"
              ? (this.ErrorMessage = "خطأ في الايميل أو كلمة المرور")
              : (this.ErrorMessage = "Wrong email or password");
            return;
          } else if (response.data.msg == "Contact our support please") {
            this.$i18n.locale == "ar"
              ? (this.ErrorMessage = "الرجاء التواصل مع فريق الدعم")
              : (this.ErrorMessage = "Please contact our support team");
            return;
          } else {
            // Use Vuex actions to set the values
            this.$store.user_type = response.data.user.type;
            this.$store.token = response.data.token;

            // Optionally store in sessionStorage
            window.sessionStorage.setItem("token", response.data.token);
            window.sessionStorage.setItem("user_type", response.data.user.type);
            store.state.loading_state = 0;
            if (response.data.user.type == "admin") {
              this.$router.push("/AdminHome");
            } else {
              this.$router.push("/");
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>
.login-view {
  background-color: var(--color-default);
  padding: 60px 0;
}
.Error {
  color: crimson;
  font-size: 12px;
  font-weight: 600;
}
/* From Uiverse.io by Yaya12085 */
.form {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  gap: 10px;
  max-width: 350px;
  background-color: #fff;
  padding: 20px;
  border-radius: 20px;
  position: relative;
}

.title {
  font-size: 28px;
  color: var(--color-default);
  font-weight: 600;
  letter-spacing: -1px;
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding-left: 30px;
}

.title::before,
.title::after {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  border-radius: 50%;
  left: 0px;
  background-color: var(--color-default);
}

.title::before {
  width: 18px;
  height: 18px;
  background-color: var(--color-default);
}

.title::after {
  width: 18px;
  height: 18px;
  -webkit-animation: pulse 1s linear infinite;
  animation: pulse 1s linear infinite;
}

.message,
.signin {
  color: rgba(88, 87, 87, 0.822);
  font-size: 14px;
}

.signin {
  text-align: center;
}

.signin a {
  color: #00b9f1;
}

.signin a:hover {
  -webkit-text-decoration: underline var(--color-primary);
  text-decoration: underline var(--color-primary);
}

.flex {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  width: 100%;
  gap: 6px;
}

.form label {
  position: relative;
}

.form label .input {
  width: 100%;
  padding: 10px 10px 20px 10px;
  outline: 0;
  border: 1px solid rgba(105, 105, 105, 0.397);
  border-radius: 10px;
}

.form label .input + span {
  position: absolute;
  top: 15px;
  color: grey;
  font-size: 0.9em;
  cursor: text;
  -webkit-transition: 0.3s ease;
  transition: 0.3s ease;
}

.form label .input:-moz-placeholder-shown + span {
  top: 15px;
  font-size: 0.9em;
}

.form label .input:-ms-input-placeholder + span {
  top: 15px;
  font-size: 0.9em;
}

.form label .input:placeholder-shown + span {
  top: 15px;
  font-size: 0.9em;
}

.form label .input:focus + span,
.form label .input:valid + span {
  top: 30px;
  font-size: 0.7em;
  font-weight: 600;
}

.form label .input:valid + span {
  color: var(--color-primary);
}

.submit {
  border: none;
  outline: none;
  background-color: var(--color-primary);
  padding: 10px;
  border-radius: 10px;
  color: #fff;
  font-size: 16px;
  -webkit-transition: 0.3s ease;
  -ms-transition: 0.3s ease;
  transition: 0.3s ease;
}

.submit:hover {
  background-color: var(--color-default);
}

@-webkit-keyframes pulse {
  from {
    -webkit-transform: scale(0.9);
    transform: scale(0.9);
    opacity: 1;
  }

  to {
    -webkit-transform: scale(1.8);
    transform: scale(1.8);
    opacity: 0;
  }
}

@keyframes pulse {
  from {
    -webkit-transform: scale(0.9);
    transform: scale(0.9);
    opacity: 1;
  }

  to {
    -webkit-transform: scale(1.8);
    transform: scale(1.8);
    opacity: 0;
  }
}
</style>
